import BaseModel from '@/api/RestModels/baseModel';
import api from './client';

class ExerciseDocumentsRestModel extends BaseModel {
  path = 'exerciseDocuments/exercise'

  getDocumentNames = async (exerciseId) => api.get(`${this.path}/${exerciseId}/documents/names`).json();

  getDocument = async (path) => api.get(`${this.path}/${path}`, { stream: true }).blob()

}

export default new ExerciseDocumentsRestModel();
